import _typeof from "@babel/runtime/helpers/typeof";
export default (function () {
  var _window$nwa, _window$nwa$getUserPr;

  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === undefined) return null;
  return (_window$nwa = window.nwa) === null || _window$nwa === void 0 ? void 0 : (_window$nwa$getUserPr = _window$nwa.getUserProp) === null || _window$nwa$getUserPr === void 0 ? void 0 : _window$nwa$getUserPr.call(_window$nwa, 'cookieId');
});